import { render, staticRenderFns } from "./doctorMsg.vue?vue&type=template&id=29707917&scoped=true&"
import script from "./doctorMsg.vue?vue&type=script&lang=js&"
export * from "./doctorMsg.vue?vue&type=script&lang=js&"
import style0 from "./doctorMsg.vue?vue&type=style&index=0&id=29707917&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29707917",
  null
  
)

export default component.exports